<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="'编码'">
              <a-input  v-model="queryParam.colCode" allowClear></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="'名称'">
              <a-input  v-model="queryParam.colName" allowClear></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="'状态'">
              <j-dict-select-tag  v-model="queryParam.status" dictCode="empzone_col_status" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchData" icon="search">{{this.language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchResetData" icon="reload" style="margin-left: 8px">{{this.language['common.resetButton']}}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <!--<a-button type="primary" icon="download" @click="handleExportXls('栏目表')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>-->
      <!-- 高级查询区域 -->
      <!--<j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>-->
    </div>

    <!-- table区域-begin -->
    <div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        @expand="expand"
        :expandedRowKeys="expandedRowKeys"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a @click="publish(record)" v-if="record.status=='N'">{{language['emp.col.status.publish']}}</a>
          <a @click="unpublish(record)" v-if="record.status=='Y'">{{language['emp.col.status.unpublish']}}</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="addChildren(record)">新增子欄目</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <empzone-col-modal ref="modalForm" @ok="modalFormOk"></empzone-col-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EmpzoneColModal from './modules/EmpzoneColModal'
  import { httpAction, getAction,postAction } from '@/api/manage'

  export default {
    name: 'EmpzoneColList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      EmpzoneColModal
    },
    data () {
      return {
        expandedRowKeys:[],
        description: '栏目表管理页面',
        // 表头
        columns: [
          {
            title:'栏目code',
            align:"center",
            dataIndex: 'colCode'
          },
          {
            title:'栏目名称',
            align:"center",
            dataIndex: 'colName'
          },
          {
            title:'栏目模板',
            align:"center",
            dataIndex: 'colType'
          },
          /*{
            title:'栏目链接',
            align:"center",
            dataIndex: 'colUrl'
          },*/
          {
            title:'状态',
            align:"center",
            dataIndex: 'status_dictText'
          },
          {
            title:'發佈時間',
            align:"center",
            dataIndex: 'publishTime',
            customRender:function (text,record) {
              if(record.status == 'Y'){
                return !text?"":(text.length>19?text.substr(0,19):text)
              }else{
                return "";
              }
            }
          },
          {
            title:'創建人',
            align:"center",
            dataIndex: 'createrName'
          },
          {
            title:'排序',
            align:"center",
            dataIndex: 'sortNo'
          },
          /*{
            title:'栏目介绍',
            align:"center",
            dataIndex: 'colDesc'
          },*/
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/empzone/col/getToplist",
          delete: "/empzone/col/delete",
          publishUrl: "/empzone/col/publishstatus",
          deleteBatch: "/empzone/col/empzonecol/batch",
          exportXlsUrl: "/empzone/col/export-xls",
          importExcelUrl: "empzone/col/import-excel",
          
        },
        dictOptions:{},
        superFieldList:[],
      }
    },
    created() {
    this.getSuperFieldList();
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      searchData(){
        this.expandedRowKeys = [];
        this.searchQuery()
      },
      searchResetData(){
        this.expandedRowKeys = [];
        this.searchReset()
      },
      addChildren(record){
        this.$refs.modalForm.addChildren(record.id,record.siteId,record.siteCode,)
      },
      initDictConfig(){
      },
      expandedRowsChange(expandedRows){
        this.expandedRowKeys = expandedRows
        console.log("expandedRows:",expandedRows)
      },
      expand(expanded,record){
        console.log("record:",record)
        if(expanded){
          getAction("/empzone/col/getChildListById",{id:record.id}).then(res=>{
            if(res.success){
              record.children = res.result;
              this.expandedRowKeys.push(record.id)
            }
          })
        }else{
          const index = this.expandedRowKeys.indexOf(record.id);
          this.expandedRowKeys.splice(index, 1);
          // this.expandedRowKeys.splice(record.id)
        }
      },
      publish(record){
        var that = this;
        //上架
        this.$confirm({
          title:'上架',
          content:'是否確認上架?',
          onOk: function(){
            getAction(that.url.publishUrl,{id:record.id,status:'Y'}).then((res)=>{
              if(res.success){
                that.$message.success(that.language["operationSuccess"]);
                that.searchData();
                // that.onClearSelected();
              }else{
                that.$message.warn(that.language['common.errorContext'])
              }
            });
          }
        });
      },
      unpublish(record){
        var that = this;
        //上架
        this.$confirm({
          title:'下架',
          content:'是否確認下架?',
          onOk: function(){
            getAction(that.url.publishUrl,{id:record.id,status:'N'}).then((res)=>{
              if(res.success){
                that.$message.success(that.language["operationSuccess"]);
                that.searchData();
                // that.onClearSelected();
              }else{
                that.$message.warn(that.language['common.errorContext'])
              }
            });
          }
        });
      },
      getSuperFieldList(){
        let fieldList=[];
        fieldList.push({type:'string',value:'siteId',text:'站点id',dictCode:''})
        fieldList.push({type:'string',value:'siteCode',text:'站点code',dictCode:''})
        fieldList.push({type:'string',value:'parentId',text:'父id',dictCode:''})
        fieldList.push({type:'string',value:'colCode',text:'栏目code',dictCode:''})
        fieldList.push({type:'string',value:'colName',text:'栏目名称',dictCode:''})
        fieldList.push({type:'string',value:'sortNo',text:'排序',dictCode:''})
        fieldList.push({type:'string',value:'colType',text:'栏目模板',dictCode:''})
        fieldList.push({type:'Text',value:'colUrl',text:'栏目链接',dictCode:''})
        fieldList.push({type:'string',value:'status',text:'状态(Y:上架；N:下架)',dictCode:''})
        fieldList.push({type:'Text',value:'colDesc',text:'栏目介绍',dictCode:''})
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
